// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#bdpPinToWidget i {
  background-color: transparent;
  color: #828282;
  cursor: pointer;
  font-size: 1.2rem;
}
#bdpPinToWidget i.fas {
  color: var(--bdpStarColor);
  font-size: 1.2rem;
}`, "",{"version":3,"sources":["webpack://./src/app/air/modules/common/component/pin-to-widget/pin-to-widget.component.scss"],"names":[],"mappings":"AACI;EACI,6BAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;AAAR;AAGI;EACI,0BAAA;EACA,iBAAA;AADR","sourcesContent":["#bdpPinToWidget {\n    i {\n        background-color: transparent;\n        color: #828282;\n        cursor: pointer;\n        font-size: 1.2rem;\n    }\n\n    i.fas {\n        color: var(--bdpStarColor);\n        font-size: 1.2rem;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
